<template src="./index.html"></template>

<script>

export default {
	
	data() {
		var NumberPass = (rule, value, callback) => {
			let reg = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,}$))/;
			console.log(reg.test(value))
			if (value === '') {
				callback(new Error('请输入内容'));
			} else if (!reg.test(value)) {
				callback(new Error('请输入包含大小写字母、数字、特殊符号在内且大于8位的密码'));
			} else {
				callback();
			}
		}
		 let checkPwd2=((rule,value,callback)=>{
		      if(value !=this.formLabelAlign.type){
		        callback(new Error("密码不一致"));
		      }else{
		        callback();
		      }
		    })
		return {
			labelPosition: 'right',
			formLabelAlign: {
				name: '',
				region: '',
				type: '',
				types: ''
			},
			show_code: false,
			Vcode_content: '获取验证码',
			showpassword:false,
			showPassword:false,
			src_img:require('../../../../assets/img/nobey.svg'),
			srcImg:require('../../../../assets/img/nobey.svg'),
			num: 0,
			rules: {
				name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				region: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				type: [{ required: true, message: '请输入密码', trigger: 'blur' },{ required: true, validator:NumberPass, trigger: 'blur' }],
				types: [{ required: true, message: '请再次输入密码', trigger: 'blur' },{ required: true, validator:checkPwd2, trigger: 'blur' }]
			}
		};
	},
	created() {},
	mounted() {},
	methods: {
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				alert('submit!');
			  } else {
				return false;
			  }
			});
		},
		show_password() {
			this.$emit('show_password', '');
		},
		input_icon_img(){
			this.showpassword = !this.showpassword
			console.log(this.src_img==require('../../../../assets/img/nobey.svg'))
			if(this.src_img==require('../../../../assets/img/nobey.svg')){
				this.src_img=require('../../../../assets/img/yesbey.svg')
			}else{
				this.src_img=require('../../../../assets/img/nobey.svg')
			}
		},
		input_icon_image(){
			console.log(this.srcImg==require('../../../../assets/img/nobey.svg'))
			this.showPassword = !this.showPassword
			if(this.srcImg==require('../../../../assets/img/nobey.svg')){
				this.srcImg=require('../../../../assets/img/yesbey.svg')
			}else{
				this.srcImg=require('../../../../assets/img/nobey.svg')
			}
		},
		verificationCode() {
			if (!this.show_code) {
				this.show_code = true;
				let num = 60;
				this.Vcode_content = num + 's';
				let time = setInterval(() => {
					if (num > 1) {
						num--;
						this.Vcode_content = num + 's';
					} else {
						this.Vcode_content = '获取验证码';
						this.show_code = false;
						clearInterval(time);
					}
				}, 1000);
			}
		}
	}
};
</script>

<style lang="less">
@import url('./index.less');
</style>
